export default {
  metaTitle: 'Edit Product',
  pageTitle: 'Edit Product -- listing',
  currentCountry: 'Current Country Site',
  selectCategory: 'Select Category',
  selected: 'Selected',
  information: 'Product Information',
  productTitle: 'Product Name',
  productShort: 'Short Description',
  pCost: 'Cost Price',
  productPicture: 'Product Images',
  sizeChartPicture: 'Size Chart Image',
  pleaseUploadSizeChart: 'Please upload size chart image.',
  productVideo: 'Product Video',
  s26_27M: '26S, 27M',
  reselect: 'Reselect',
  tips1: 'Video is limited to 30S and 30MB',
  productType: 'Product Type',
  radio1: 'Multi SKU',
  radio2: 'Single SKU',
  style: 'Display Variation(Style) Valune by default',
  radio3: 'Other input',
  specifications: 'Selected Variations',
  content1: 'Color is typically used to describe differences in appearance.',
  content2: 'Size is typically used to describe dimensions or capacity.',
  content3: 'Style is typically used to describe product variations where Size and Color do not apply.',
  content4: 'For clothing, if the only difference is in color, please use only Color.',
  content5: 'For phones, if the only difference is in capacity, please use only Size. If there are differences in both capacity and color, please use Size and Color together.',
  content6: 'For products like bed sheets with pattern differences, please use Style for these custom variations.',
  size: 'Size',
  addSize: 'Add customized size',
  placeholder1: 'Input here',
  selectAddSize: 'Selected Or Added Size',
  color: 'Color',
  addColor: 'Add customized color',
  selectAddColor: 'Selected Or Added Color',
  styles: 'Style',
  addStyle: 'Add customized style',
  selectAddStyle: 'Selected Or Added Style',
  listSKU: 'SKU list',
  onclick: 'Batch Apply',
  listPrice: 'Market Referece Price',
  salePrice: 'Selling Price',
  stock: 'Inventory',
  vendorProductId: 'Vendor Product ID',
  checkbox1: 'For SKUs without uploaded thumbnail images, automatically select the first image from the product carousel as the thumbnail for the current SKU.',
  checkbox2: 'To enhance seller operational efficiency, we have added a Batch Apply feature. You can enter relevant information in this section and, by clicking Batch Apply to  apply it to all the SKUs listed below.',
  apy: 'Apply',
  transportation: 'Logistics Related Information',
  grossWeight: 'Gross Weight',
  withBattery: 'Battery included?',
  partially: 'Partially',
  withMagnetic: 'Magnetic included?',
  powder: 'Powder included?',
  compressionAgent: 'Compressor included?',
  content7: `Please fill in the above information truthfully. The seller will take all the responsibility and loss of the cases caused by wrongly input information of product as custom rejection or accidents.`,
  otherInformation: 'Other Information',
  selectStoreCategory: 'Select Store Category',
  productDetails: 'Product Description Editing',
  selectWarehouse: 'Select Warehouse',
  settingWarehouse: 'Payment settings of the warehouse',
  pay1: 'Online payment',
  pay2: 'Pay On Delivery',
  payMethod: 'Payment Method',
  online: 'Online Payment',
  publishOptions: 'Publish Options',
  radio4: 'Active',
  radio5: 'Inactive',
  radio6: 'Publish and keep current status',
  first: '3C',
  column1: 'Size',
  column2: 'Color',
  column3: 'Style',
  column4: 'Market Reference Price',
  column5: 'Selling Price',
  column6: 'Cost Price',
  column7: 'Cost Price',
  column8: 'Vendor Product ID',
  column9: 'Inventory',
  column10: 'Mark',
  column11: 'Operation',
  column12: 'Thumbnail',
  marks1: 'Marked for deletion',
  marks2: 'Cancel deletion mark',
  choose: 'Select',
  error1: 'Apply failed. You did not enter anything.',
  error2: 'Upload up to 5 images.',
  error3: 'Please upload JPG GIF or PNG images.',
  error4: 'The file is too large, please do not exceed 2M.',
  info1: 'Upload up to 10 images',
  infoa: 'Upload up to ',
  infob: 'images',
  error5: 'The video length must be less than or equal to 30 seconds.',
  error6: 'Only support mp4 format',
  error7: 'No more than 30M',
  warning1: 'This variaton value already exists!',
  error8: 'Please enter product name!',
  error9: 'Please upload image',
  error10: 'Please upload SKU thumbnail',
  error11: 'Please enter gross weight!',
  error12: 'Please set payment method',
  error13: 'Please select warehouse',
  error14: 'Please select store category',
  error15: 'Please enter inventory',
  error16: 'Please select image',
  error17: 'Selling price have to be greater than 0',
  error18: 'Market reference price have to be greater than 0',
  error19: 'Selling price have to be less than market reference price!',
  error20: 'Select at least one variation',
  success1: 'Success',
  successOk: 'Confirm',
  error21: 'This product does not support the full-edit function',
  info2: 'Upload up to 10 files once',
  taxClass: 'Tax class',
  customCodeName: 'Custom Code Name',
  customCode: 'Custom Code',
  customCodeAttribute: 'Custom Code Attribute',
  isItFragile: 'Is it fragile',
  youNotKeepActiveOnline: 'You can not active/keep active this products when all variations are inactive.',
  wgUnlock: 'The product is locked,please release first.',
  youNotKeepInactiveOnline: 'You can not inactive/keep inactive this products when some variations of this product are active.',
  customCodeNameCN: 'Product Name(CN)',
  customDeclaredValueCNY: 'Custom Declared Value(CNY)',
  applyToChangeCategory: 'Apply to change category',
  changeLog: 'Change Log',
  id: 'ID',
  originalCategory: 'Original Category',
  changedCategory: 'Changed Category',
  status: 'Status',
  applyDate: 'Apply Date',
  auditDate: 'Audit Date',
  operation: 'Operation',
  inReview: 'In Review',
  approved: 'Approved',
  rejected: 'Rejected',
  canceled: 'Canceled',
  cancel: 'Cancel',
  sureCancelOperation: 'Are you sure to proceed with the cancellation operation?',
  confirm: 'Confirm',
  cancelSuccess: 'Cancel Success',
  changeCategory: 'Change Category',
  remainingChances: 'Remaining chances',
  current: 'Current',
  changeTo: 'Change to',
  changingCategoriesMayLosses: 'Changing categories may result in the following risks or losses:',
  instructions1: '1. The product weight will be recalculated, which may temporarily affect the product ranking;',
  instructions2: '2. The product information quality score will be recalculated, which may affect the product ranking;',
  instructions3: '3. QC review under the new category may be triggered.',
  confirmToChange: 'Confirm to change',
  currentSameAsChangeTo: 'Current category is the same as the category to change to. Please select a different category.'
}
